module.exports = __webpack_public_path__ + "img/logo_100.f0ffcef0.png";